module.exports = __webpack_public_path__ + "static/media/minus-30s.ce6c9354.svg";